<!-- Asientos Coche Mix -->
<div class="col-lg-12 pt-4">
    <div class="ps-4 pt-5 pb-4 bg-grey pe-4 radius-30">
        <div class="row mb-4">
            <div class="col-xxl-3 col-lg-12 col-12">
                <h3 class="mb-3 mb-xxl-0 text-center text-lg-start">Planta Alta</h3>
            </div>
            <div class="col-xxl-9 col-lg-12 col-12 planta-alta">
                <div class="buss">
                    <ol class="cabin fuselage">
                        <li class="row row--1">
                            <ol class="seats" type="A">
                            <li class="seat"  [ngClass]="checkAsientoReserva('01')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="01" [checked]="checkAsiento('01') || checkAsientoSelected('01')" (change)="revisarCambio('01')"/>
                                <label for="01">01</label>
                            </li>
                            <li class="seat"  [ngClass]="checkAsientoReserva('05')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="05" [checked]="checkAsiento('05') || checkAsientoSelected('05')" (change)="revisarCambio('05')"/>
                                <label for="05">05</label>
                            </li>
                            <li class="seat escalera" [ngClass]="checkAsientoReserva('09')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                              <input type="checkbox" id="09" [checked]="checkAsiento('09') || checkAsientoSelected('09')" (change)="revisarCambio('09')"/>
                                <label for="09">09</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('17')|| bloquear?'disable-checkbox':''" >
                              <div class="cover"></div>
                                <input type="checkbox" id="17" [checked]="checkAsiento('17') || checkAsientoSelected('17')" (change)="revisarCambio('17')"/>
                                <label for="17">17</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('21')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="21" [checked]="checkAsiento('21') || checkAsientoSelected('21')" (change)="revisarCambio('21')"/>
                                <label for="21">21</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('25')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="25" [checked]="checkAsiento('25') || checkAsientoSelected('25')" (change)="revisarCambio('25')"/>
                                <label for="25">25</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('29')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="29" [checked]="checkAsiento('29') || checkAsientoSelected('29')" (change)="revisarCambio('29')"/>
                                <label for="29">29</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('33')|| bloquear?'disable-checkbox':''" >
                              <div class="cover"></div>
                                <input type="checkbox" id="33" [checked]="checkAsiento('33') || checkAsientoSelected('33')" (change)="revisarCambio('33')"/>
                                <label for="33">33</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('37')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="37" [checked]="checkAsiento('37') || checkAsientoSelected('37')" (change)="revisarCambio('37')"/>
                                <label for="37">37</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('41')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="41" [checked]="checkAsiento('41') || checkAsientoSelected('41')" (change)="revisarCambio('41')"/>
                                <label for="41">41</label>
                            </li>
                            </ol>
                        </li>
                        <li class="row row--1">
                            <ol class="seats" type="A">
                            <li class="seat" [ngClass]="checkAsientoReserva('02')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="02" [checked]="checkAsiento('02') || checkAsientoSelected('02')" (change)="revisarCambio('02')"/>
                                <label for="02">02</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('06')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="06" [checked]="checkAsiento('06') || checkAsientoSelected('06')" (change)="revisarCambio('06')"/>
                                <label for="06">06</label>
                            </li>
                            <li class="seat escalera" [ngClass]="checkAsientoReserva('10')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="10" [checked]="checkAsiento('10') || checkAsientoSelected('10')" (change)="revisarCambio('10')"/>
                                <label for="10">10</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('18')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="18" [checked]="checkAsiento('18') || checkAsientoSelected('18')" (change)="revisarCambio('18')"/>
                                <label for="18">18</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('22')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="22" [checked]="checkAsiento('22') || checkAsientoSelected('22')" (change)="revisarCambio('22')"/>
                                <label for="22">22</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('26')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="26" [checked]="checkAsiento('26') || checkAsientoSelected('26')" (change)="revisarCambio('26')"/>
                                <label for="26">26</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('30')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="30" [checked]="checkAsiento('30') || checkAsientoSelected('30')" (change)="revisarCambio('30')"/>
                                <label for="30">30</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('34')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="34" [checked]="checkAsiento('34') || checkAsientoSelected('34')" (change)="revisarCambio('34')"/>
                                <label for="34">34</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('38')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="38" [checked]="checkAsiento('38') || checkAsientoSelected('38')" (change)="revisarCambio('38')"/>
                                <label for="38">38</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('42')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="42" [checked]="checkAsiento('42') || checkAsientoSelected('42')" (change)="revisarCambio('42')"/>
                                <label for="42">42</label>
                            </li>
                            </ol>
                        </li>
                        <li class="row row--2 mt-4">
                            <ol class="seats" type="A">
                            <li class="seat" [ngClass]="checkAsientoReserva('04')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="04" [checked]="checkAsiento('04') || checkAsientoSelected('04')" (change)="revisarCambio('04')"/>
                                <label for="04">04</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('08')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="08" [checked]="checkAsiento('08') || checkAsientoSelected('08')" (change)="revisarCambio('08')"/>
                                <label for="08">08</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('12')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="12" [checked]="checkAsiento('12') || checkAsientoSelected('12')" (change)="revisarCambio('12')"/>
                                <label for="12">12</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('14')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox"  id="14" [checked]="checkAsiento('14') || checkAsientoSelected('14')" (change)="revisarCambio('14')"/>
                                <label for="14">14</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('16')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox"  id="16" [checked]="checkAsiento('16') || checkAsientoSelected('16')" (change)="revisarCambio('16')"/>
                                <label for="16">16</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('20')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="20" [checked]="checkAsiento('20') || checkAsientoSelected('20')" (change)="revisarCambio('20')"/>
                                <label for="20">20</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('24')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="24" [checked]="checkAsiento('24') || checkAsientoSelected('24')" (change)="revisarCambio('24')"/>
                                <label for="24">24</label>
                                </li>
                                <li class="seat" [ngClass]="checkAsientoReserva('28')|| bloquear?'disable-checkbox':''">
                                  <div class="cover"></div>
                                <input type="checkbox" id="28" [checked]="checkAsiento('28') || checkAsientoSelected('28')" (change)="revisarCambio('28')"/>
                                <label for="28">28</label>
                                </li>
                                <li class="seat" [ngClass]="checkAsientoReserva('32')|| bloquear?'disable-checkbox':''">
                                  <div class="cover"></div>
                                <input type="checkbox" id="32" [checked]="checkAsiento('32') || checkAsientoSelected('32')" (change)="revisarCambio('32')"/>
                                <label for="32">32</label>
                                </li>
                                <li class="seat" [ngClass]="checkAsientoReserva('36')|| bloquear?'disable-checkbox':''">
                                  <div class="cover"></div>
                                <input type="checkbox" id="36" [checked]="checkAsiento('36') || checkAsientoSelected('36')" (change)="revisarCambio('36')"/>
                                <label for="36">36</label>
                                </li>
                                <li class="seat" [ngClass]="checkAsientoReserva('40')|| bloquear?'disable-checkbox':''">
                                  <div class="cover"></div>
                                <input type="checkbox" id="40" [checked]="checkAsiento('40') || checkAsientoSelected('40')" (change)="revisarCambio('40')"/>
                                <label for="40">40</label>
                                </li>
                                <li class="seat" [ngClass]="checkAsientoReserva('44')|| bloquear?'disable-checkbox':''">
                                  <div class="cover"></div>
                                <input type="checkbox" id="44" [checked]="checkAsiento('44') || checkAsientoSelected('44')" (change)="revisarCambio('44')"/>
                                <label for="44">44</label>
                                </li>
                            </ol>
                        </li>

                        <li class="row row--2">
                            <ol class="seats" type="A">
                            <li class="seat" [ngClass]="checkAsientoReserva('03')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="03" [checked]="checkAsiento('03') || checkAsientoSelected('03')" (change)="revisarCambio('03')"/>
                                <label for="03">03</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('07')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="07" [checked]="checkAsiento('07') || checkAsientoSelected('07')" (change)="revisarCambio('07')"/>
                                <label for="07">07</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('11')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="11" [checked]="checkAsiento('11') || checkAsientoSelected('11')" (change)="revisarCambio('11')"/>
                                <label for="11">11</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('13')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="13" [checked]="checkAsiento('13') || checkAsientoSelected('13')" (change)="revisarCambio('13')"/>
                                <label for="13">13</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('15')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="15" [checked]="checkAsiento('15') || checkAsientoSelected('15')" (change)="revisarCambio('15')"/>
                                <label for="15">15</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('19')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="19" [checked]="checkAsiento('19') || checkAsientoSelected('19')" (change)="revisarCambio('19')"/>
                                <label for="19">19</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('23')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="23" [checked]="checkAsiento('23') || checkAsientoSelected('23')" (change)="revisarCambio('23')"/>
                                <label for="23">23</label>
                                </li>
                                <li class="seat" [ngClass]="checkAsientoReserva('27')|| bloquear?'disable-checkbox':''">
                                  <div class="cover"></div>
                                <input type="checkbox" id="27" [checked]="checkAsiento('27') || checkAsientoSelected('27')" (change)="revisarCambio('27')"/>
                                <label for="27">27</label>
                                </li>
                                <li class="seat" [ngClass]="checkAsientoReserva('31')|| bloquear?'disable-checkbox':''">
                                  <div class="cover"></div>
                                <input type="checkbox" id="31" [checked]="checkAsiento('31') || checkAsientoSelected('31')" (change)="revisarCambio('31')"/>
                                <label for="31">31</label>
                                </li>
                                <li class="seat" [ngClass]="checkAsientoReserva('35')|| bloquear?'disable-checkbox':''">
                                  <div class="cover"></div>
                                <input type="checkbox" id="35" [checked]="checkAsiento('35') || checkAsientoSelected('35')" (change)="revisarCambio('35')"/>
                                <label for="35">35</label>
                                </li>
                                <li class="seat" [ngClass]="checkAsientoReserva('39')|| bloquear?'disable-checkbox':''">
                                  <div class="cover"></div>
                                <input type="checkbox" id="39" [checked]="checkAsiento('39') || checkAsientoSelected('39')" (change)="revisarCambio('39')"/>
                                <label for="39">39</label>
                                </li>
                                <li class="seat" [ngClass]="checkAsientoReserva('43')|| bloquear?'disable-checkbox':''">
                                  <div class="cover"></div>
                                <input type="checkbox" id="43" [checked]="checkAsiento('43') || checkAsientoSelected('43')" (change)="revisarCambio('43')"/>
                                <label for="43">43</label>
                                </li>
                            </ol>
                        </li>

                    </ol>
                </div>

            </div>
        </div>
        <div class="row mb-4">
            <div class="col-xxl-3 col-lg-12  col-12">
                <h3 class="mb-3 mb-xxl-0 text-center text-lg-start">Planta Baja</h3>
            </div>
            <div class="col-lg-12 col-xxl-4 col-12 mb-lg-4 mb-xxl-0 planta-baja">
                <div class="buss">
                    <ol class="cabin fuselage">
                        <li class="row row--1">
                            <ol class="seats" type="A">
                            <li class="seat" [ngClass]="checkAsientoReserva('45')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="45" [checked]="checkAsiento('45') || checkAsientoSelected('45')" (change)="revisarCambio('45')"/>
                                <label for="45">45</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('48')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="48" [checked]="checkAsiento('48') || checkAsientoSelected('48')" (change)="revisarCambio('48')"/>
                                <label for="48">48</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('51')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="51" [checked]="checkAsiento('51') || checkAsientoSelected('51')" (change)="revisarCambio('51')"/>
                                <label for="51">51</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('54')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="54" [checked]="checkAsiento('54') || checkAsientoSelected('54')" (change)="revisarCambio('54')"/>
                                <label for="54">54</label>
                            </li>

                            </ol>
                        </li>

                        <li class="row row--2 mt-4">
                            <ol class="seats" type="A">
                            <li class="seat" [ngClass]="checkAsientoReserva('46')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="46" [checked]="checkAsiento('46') || checkAsientoSelected('46')" (change)="revisarCambio('46')"/>
                                <label for="46">46</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('50')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="50" [checked]="checkAsiento('50') || checkAsientoSelected('50')" (change)="revisarCambio('50')"/>
                                <label for="50">50</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('52')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="52" [checked]="checkAsiento('52') || checkAsientoSelected('52')" (change)="revisarCambio('52')"/>
                                <label for="52">52</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('56')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="56" [checked]="checkAsiento('56') || checkAsientoSelected('56')" (change)="revisarCambio('56')"/>
                                <label for="56">56</label>
                            </li>

                            </ol>
                        </li>

                        <li class="row row--2">
                            <ol class="seats" type="A">
                            <li class="seat" [ngClass]="checkAsientoReserva('47')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="47" [checked]="checkAsiento('47') || checkAsientoSelected('47')" (change)="revisarCambio('47')"/>
                                <label for="47">47</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('49')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="49" [checked]="checkAsiento('49') || checkAsientoSelected('49')" (change)="revisarCambio('49')"/>
                                <label for="49">49</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('53')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="53" [checked]="checkAsiento('53') || checkAsientoSelected('53')" (change)="revisarCambio('53')"/>
                                <label for="53">53</label>
                            </li>
                            <li class="seat" [ngClass]="checkAsientoReserva('55')|| bloquear?'disable-checkbox':''">
                              <div class="cover"></div>
                                <input type="checkbox" id="55" [checked]="checkAsiento('55') || checkAsientoSelected('55')" (change)="revisarCambio('55')"/>
                                <label for="55">55</label>
                            </li>

                            </ol>
                        </li>

                    </ol>
                </div>

            </div>
            <div class="col-xxl-4 col-12 align-self-end">
                <div class="align-items-center d-flex flex-row justify-content-xxl-end mb-3">
                    <p class="mb-0 pe-2">Asientos disponibles</p>
                    <div class="unchecked"></div>
                </div>
                <div class="align-items-center d-flex flex-row justify-content-xxl-end ">
                    <p class="mb-0 pe-2">Asientos no disponibles</p>
                    <div class="checked"></div>
                </div>
            </div>
        </div>

    </div>
</div>
